import { preventBodyScroll } from '../core/helper-functions'

module.exports = {
  props: ['order', 'formats', 'translation', 'isedit'],
  data () {
    return {
      visible: false
    }
  },

  computed: {
    softcover () {
      return this.formats.find(item => item.id === 1)
    },

    hardcover () {
      return this.formats.find(item => item.id === 2)
    }
  },

  methods: {
    open () {
      this.visible = true
      preventBodyScroll(true)
    },
    close () {
      this.visible = false
      preventBodyScroll(false)
    },
    select (item) {
      if (this.isedit) {
        if (this.order.bookFormat.id === item.id) {
          this.close()
        } else {
          this.$emit('update:format', item)
          this.$emit('save-order')
          this.$emit('add-to-cart', { cb: this.close, updateBookFormat: true })
        }
      } else {
        this.$emit('update:format', item)
        this.$emit('save-order')
        this.$emit('add-to-cart', {})
      }
    },
  },

  template: `
    <div class="relative">
      <transition name="fade">
        <div v-if="visible" @click="close" class="hero-modal p-md-4 text-md-left d-flex justify-content-center align-items-center">
          <div @click.stop class="hero-modal__wrapper">
            <div class="hero-modal__book-format relative">

              <p @click="close" class="hero-modal__close h-pointer h-text-grey-cl-450 d-flex align-items-center"><span class="mr-2">close</span> <i class="icon-close"></i></p>
              <h2 class="heading-4 m-0 h-text-grey-cl-900 h-font-barlow font-weight-bold">{{translation['Book Format']}}</h2>
              <p class="h-text-grey-cl-900 mb-4">{{translation['Choose a format for your book from the options below.']}}</p>

              <div class="d-md-flex">
                <div class="w-md-50 pr-md-2">
                  <div class="hero-modal__block text-center">
                    <div class="relative">
                      <div class="hero-modal__price h-font-playtime text-white">
                        <p class="hero-modal__price-cost font-weight-bold ">{{ softcover.price }}</p>
                      </div>
                      <img class="hero-modal__book-format__image" src="/static/personal_book_app/img/home/book-formats/softcover.jpg" alt="softcover">
                    </div>
                    <p class="title-6 h-text-grey-cl-900 font-weight-bold mt-3">{{ softcover.title }}</p>
                    <p class="h-text-grey-cl-450 mt-3 px-2 title-8">Our premium softcover is made with beautiful, thick, quality paper.</p>
                    <button class="main-btn main-btn--green-light mt-3 mb-4" @click="select(softcover)">{{translation['Select']}}</button>
                  </div>
                </div>

                <div class="w-md-50 pl-md-2 mt-4 mt-md-0">
                  <div class="hero-modal__block text-center">
                    <div class="relative">
                      <div class="hero-modal__price h-font-playtime text-white">
                        <p class="hero-modal__price-cost font-weight-bold">{{ hardcover.price }}</p>
                      </div>
                      <img class="hero-modal__book-format__image" src="/static/personal_book_app/img/home/book-formats/hardcover.jpg" alt="hardcover">
                    </div>
                    <p class="title-6 h-text-grey-cl-900 font-weight-bold mt-3">{{ hardcover.title }}</p>
                    <p class="h-text-grey-cl-450 mt-3 px-2 title-8">Our premium hardcover adds extra durability and sturdiness to the book.</p>
                    <button class="main-btn main-btn--green-light mt-3 mb-4" @click="select(hardcover)">{{translation['Select']}}</button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  `
}
